export default{
    data(){
        return{
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/widgets.js